import { MissionMap_Entity } from "../entities/missionMap";
import { Inspector } from "../entities/missionMap/missionMap";
import { rhapsodyApi } from "./api";

export const missionEndpoints = rhapsodyApi.injectEndpoints({
  endpoints: (build) => ({
    getMissionMap: build.query<MissionMap_Entity, string>({
      query: (token) => `missions/public/${token}`,
      providesTags: ["missions"],
    }),
    releaseRequest: build.mutation<
      void,
      {
        publicToken?: string;
        releaseWorkSessionIDs?: string;
        releaseExplanation?: string;
      }
    >({
      query: (body) => ({
        method: "PUT",
        body: body,
        url: `missions/releaseRequest`,
      }),
      // Refetch the mapping so the "You asked for a release" alert replaces
      // the "Ask to be released" link without a reload, as `answer` does.
      invalidatesTags: () => ["missions"],
    }),
    answer: build.mutation<
      MissionMap_Entity,
      {
        [key: string]: {
          mercuryInteractorID?: number;
          jobStageID?: number;
          mercuryInspectors?: Partial<Inspector>[];
          grouped?: boolean;
        };
      }
    >({
      query: (body) => ({
        method: "PUT",
        body: body,
        url: `missions/mercuryPublic`,
      }),
      invalidatesTags: () => ["missions"],
    }),
  }),
});

export const {
  useGetMissionMapQuery,
  useLazyGetMissionMapQuery,
  useAnswerMutation,
  useReleaseRequestMutation,
} = missionEndpoints;

export default missionEndpoints;
